module.exports = __webpack_public_path__ + "img/napravlen-11.07f16bc3.png";